<template>
  <confirm-modal ref="modal" confirm="Удалить" reset="Отменить" mode="danger" @confirm="confirm">
    <span>
      Подтвердите удаление
      {{ category === "sick" ? "больничного" : "отпуска" }} сотрудника
      <b>{{ worker }}</b>
    </span>
  </confirm-modal>
</template>

<script>
import ConfirmModal from "@/components/modals/confirm-modal";

export default {
  name: "remove-type-modal",
  components: { ConfirmModal },
  data() {
    return {
      category: "vacation",
      id: null,
      worker: "",
    };
  },
  computed: {
    title() {
      return this.category === "sick" ? "Удаление больничного" : "Удаление отпуска";
    },
  },
  methods: {
    open(period) { 
      this.category = period.category;
      this.id = period.id;
      this.worker = period.worker.name;
      this.$refs.modal.open({
        title: this.title,
      });
    },
    close() {
      this.$refs.modal.close();
      this.category = "vacation";
      this.worker = "";
      this.id = null;
    },
    confirm() {
      this.$store.dispatch("vacationsChart/removeVacation", { id: this.id }).then(() => {
        this.close();
        setTimeout(() => {
          this.$emit("remove");
        });
      });
    },
  },
};
</script>
